/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {},
  rules: [],
  tokens: {
    color: '#414547',
    fontName: 'HNforTELUSSA',
    fontSize: 12,
    fontWeight: '500',
    lineHeight: 1.33333333333
  }
}
export default theme
